var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRewardsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    enableBackground: "new 0 0 48 48",
    xmlSpace: "preserve",
    viewBox: "7.98 2.71 32.04 43.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M19.234,2.707l-2.355,5.238L11.156,8.43l1.172,5.617L7.98,17.801l4.254,3.859l-1.309,5.594l5.707,0.621  l2.23,5.297l4.984-2.855l4.914,2.977l2.355-5.238l5.727-0.484l-1.172-5.617l4.348-3.754l-4.254-3.859l1.309-5.594l-5.711-0.621  l-2.23-5.297l-4.984,2.855L19.234,2.707z M34,31.824l-0.199,0.02l-1.391,3.09l-1.852,4.121l-3.863-2.34l-2.902-1.754l-2.938,1.684  l-3.922,2.242l-1.754-4.164L14,31.922V46l10-5l10,5V31.824z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardsIcon);
export default __webpack_public_path__ + "static/media/rewards-icon.def48241185af9bd97a9bab418d046e8.svg";
export { ForwardRef as ReactComponent };